import clsx from 'clsx'
import { type ReactNode } from 'react'
import { NavLink, type NavLinkProps } from 'react-router-dom'

type NavigationLinkProps = NavLinkProps & {
  children: ReactNode
}

export const NavigationLink = ({ children, ...props }: NavigationLinkProps) => {
  return (
    <div className="relative h-9">
      <NavLink
        className={({ isActive }) =>
          clsx('whitespace-nowrap flex items-center h-full text-grey-700 font-normal text-base', {
            'font-semibold after:rounded-full text-grey-800 after:block after:absolute after:bottom-0 after:w-full after:h-1 after:translate-y-1/2 after:bg-secondary-light':
              isActive,
          })
        }
        {...props}
      >
        {children}
      </NavLink>
    </div>
  )
}
